import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

export const useRouteChange = (onRouteChange?: (path: string) => void) => {
  const pathname = usePathname()
  const currentPath = useRef<string | null>(null)

  useEffect(() => {
    // Initial path
    if (!currentPath.current) {
      currentPath.current = pathname
      onRouteChange?.(pathname)
    }

    // Subsequent path change
    if (pathname !== currentPath.current) {
      currentPath.current = pathname
      onRouteChange?.(pathname)
    }
  }, [pathname, onRouteChange])

  return {
    path: pathname,
  }
}
